import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { RequestOptions, RequestResponse } from './interfaces/request.interface';

import { environment } from '@environments/environment';
import { Observable, catchError, map, throwError } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class HttpRequestService {
  protected readonly http = inject(HttpClient);
  protected readonly api = environment.API_URL;
  protected readonly router = inject(Router);

  public get<T>(endpoint: string, options?: RequestOptions): Observable<T> {
    return this.http.get<T>(`${this.api}${endpoint}`, {
      ...options,
      observe: 'response',
      responseType: 'json'
    }).pipe(
      map((res: HttpResponse<T>) => {
        return res.body as T;
    }),
    catchError((error: HttpErrorResponse) => {
      let detail: string;
      if (error.status === 401) {
        this.logout();
      } else if(error.status === 422) {
        detail = 'Error al enviar los datos.';
      } else {
        detail = error && error.error && error.error.detail ? error.error.detail : 'Ha ocurrido un error en el servidor.'
      }

      return throwError(() => detail);
    })
  );
  }

  public postUser<T>(endpoint: string, body: any, options?: RequestOptions): Observable<T> {
    return this.http.post<T>(`${this.api}${endpoint}`, body, {
      ...options,
      observe: 'response',
      responseType: 'json'
    }).pipe(
      map((res: HttpResponse<T>) => {
        return res.body as T;
      }),

      catchError((error: any) => {
        const detail = error && error.error && error.error.detail ? error.error.detail : 'Ha ocurrido un error en el servidor.'
        return throwError(() => detail);
      })
    );
  }

  public put<T>(endpoint: string, body: any, options?: RequestOptions): Observable<T> {
    return this.http.put<T>(`${this.api}${endpoint}`, body, {
      ...options,
      observe: 'response',
      responseType: 'json'
    }).pipe(
      map((res: HttpResponse<T>) => {
        return res.body as T;
      }),

      catchError((error: any) => {
        let detail: string;
        if (error.status === 401) {
          this.logout();
        } else if(error.status === 422) {
          detail = 'Error al enviar los datos.';
        } else {
          detail = error && error.error && error.error.detail ? error.error.detail : 'Ha ocurrido un error en el servidor.'
        }

        return throwError(() => detail);
      })
    );
  }

    public getFile(endpoint: string): Observable<Blob> {
    return this.http.get(`${this.api}${endpoint}`, {responseType: 'blob'});
  }

  public post<T>(endpoint: string, body: any, options?: RequestOptions): Observable<T> {
    return this.http.post<T>(`${this.api}${endpoint}`, body, {
      ...options,
      observe: 'response',
      responseType: 'json'
    }).pipe(
      map((res: HttpResponse<T>) => {
        // console.log(res)
        return res.body as T;
      }),

      catchError((error: HttpErrorResponse) => {
        let detail: string;
        if (error.status === 401) {
          this.logout();
        } else if(error.status === 422) {
          detail = 'Error al enviar los datos.';
        } else {
          detail = error && error.error && error.error.detail ? error.error.detail : 'Ha ocurrido un error en el servidor.'
        }

        return throwError(() => detail);
      })
    );
  }

  public delete<T>(endpoint: string, options?: RequestOptions): Observable<T> {
    return this.http.delete<T>(`${this.api}${endpoint}`, {
      ...options,
      observe: 'response',
      responseType: 'json'
    }).pipe(
      map((res: HttpResponse<T>) => {
        // console.log(res)
        return res.body as T;
      }),

      catchError((error: HttpErrorResponse) => {
        let detail: string;
        if (error.status === 401) {
          this.logout();
        } else if(error.status === 422) {
          detail = 'Error al enviar los datos.';
        } else {
          detail = error && error.error && error.error.detail ? error.error.detail : 'Ha ocurrido un error en el servidor.'
        }

        return throwError(() => detail);
      })
    );
  }

  public logout(){
    localStorage.clear();
    this.router.navigate(['/auth/iniciar-sesion'])
  }
}
